module.exports = __webpack_public_path__ + "img/coming.soon.5648ebbe.png";